export const CLICK_DISTANCE_THRESHOLD = 4

export const ARROW_KEY_STEP = 4
export const ARROW_KEY_STEP_LARGE = 16

export const RESIZE_HANDLE_SIZE = 8
export const MIN_WIDGET_SIZE = 8
